(function () {
  const CONTAINER_SELECTOR = '.mag-article__content:not(.mag-article__content--gated), .mag-article__content-partial';
  const GROUP_CLASS = 'mag-article__table-group';
  const HINT_CLASS = 'mag-article__table-hint';
  const FRAME_CLASS = 'mag-article__table-frame';
  const FADE_CLASS = 'mag-article__table-fade';
  let hintCount = 0;

  const isScrollRegion = (element) => {
    const overflowX = getComputedStyle(element).overflowX;
    return overflowX === 'auto' || overflowX === 'scroll';
  };

  const createHintId = () => {
    let id;
    do {
      hintCount += 1;
      id = `mag-article-table-hint-${hintCount}`;
    } while (document.getElementById(id));
    return id;
  };

  const setDescribedBy = (region, id, active) => {
    const ids = (region.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (ids.includes(id) === active) return;

    const nextIds = active ? ids.concat(id) : ids.filter((value) => value !== id);
    if (nextIds.length) {
      region.setAttribute('aria-describedby', nextIds.join(' '));
    } else {
      region.removeAttribute('aria-describedby');
    }
  };

  const createFade = (edge) => {
    const fade = document.createElement('span');
    fade.className = `${FADE_CLASS} ${FADE_CLASS}--${edge}`;
    fade.setAttribute('aria-hidden', 'true');
    return fade;
  };

  const enhanceRegion = (region, text) => {
    if (region.parentElement.classList.contains(FRAME_CLASS)) return;

    const group = document.createElement('div');
    const hint = document.createElement('p');
    const frame = document.createElement('div');
    group.className = GROUP_CLASS;
    hint.className = HINT_CLASS;
    hint.id = createHintId();
    hint.textContent = text;
    hint.hidden = true;
    frame.className = FRAME_CLASS;
    region.before(group);
    frame.append(region, createFade('start'), createFade('end'));
    group.append(hint, frame);

    const updateFades = () => {
      // Tolerate a 1px rounding difference.
      const maxScroll = region.scrollWidth - region.clientWidth;
      const scrollable = maxScroll > 1;
      frame.toggleAttribute('data-fade-start', scrollable && region.scrollLeft > 1);
      frame.toggleAttribute('data-fade-end', scrollable && region.scrollLeft < maxScroll - 1);
      // Keeps the fades off a visible horizontal scrollbar.
      frame.style.setProperty('--mag-table-scrollbar', `${region.offsetHeight - region.clientHeight}px`);
      return scrollable;
    };

    const update = () => {
      const scrollable = updateFades();
      hint.hidden = !scrollable;
      setDescribedBy(region, hint.id, scrollable);
    };

    let fadeQueued = false;
    region.addEventListener(
      'scroll',
      () => {
        if (fadeQueued) return;
        fadeQueued = true;
        requestAnimationFrame(() => {
          fadeQueued = false;
          updateFades();
        });
      },
      { passive: true }
    );

    if ('ResizeObserver' in window) {
      new ResizeObserver(update).observe(region, { box: 'border-box' });
    } else {
      window.addEventListener('resize', update);
    }
    update();
  };

  const initTables = (scope) => {
    scope.querySelectorAll(CONTAINER_SELECTOR).forEach((container) => {
      const article = container.closest('[data-mag-table-hint]');
      const text = article ? article.dataset.magTableHint.trim() : '';
      if (!text) return;

      container.querySelectorAll('table').forEach((table) => {
        const region = table.parentElement;
        if (region !== container && isScrollRegion(region)) enhanceRegion(region, text);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initTables(document));
  } else {
    initTables(document);
  }

  document.addEventListener('shopify:section:load', (event) => initTables(event.target));
})();
